import styled from 'styled-components';

export const Root = styled.div`
    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        padding-right: 125px;
    }
`;

export const ChipText = styled.span`
    // TODO: Should use typography reset.
    font-family: 'Alliance No.1';
    font-style: normal;
    font-weight: 500;
    line-height: 1;
    font-size: 0.75rem;
    color: ${(props) => props.theme.shades.white['80']};
`;

export const AddMembersWrapper = styled.div`
    position: relative;
`;
